










































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storePile, {PileFilter} from '@/stores/modules/pile';

import InputDateFilter from '@/components/Input/DateFilter.vue';
import CrudFournisseurSearch from '@/components/Crud/Fournisseur/Search.vue';

@Component({
	components: {
		InputDateFilter,
		CrudFournisseurSearch,
	}
})
export default class CrudPileFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce;

	@Stored(() => storePile) private page!: number;
	@Stored(() => storePile) private filters!: PileFilter;

	@WatchObjectProperties('filters', PileFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storePile.dispatch('getC', { filters: true });
	}

	public mounted() {
	    this.filters = new PileFilter();
	}
}
